import { render, staticRenderFns } from "./CreateCompetitorDialog.vue?vue&type=template&id=4109bf9f&scoped=true&"
import script from "./CreateCompetitorDialog.vue?vue&type=script&lang=js&"
export * from "./CreateCompetitorDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateCompetitorDialog.vue?vue&type=style&index=0&id=4109bf9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4109bf9f",
  null
  
)

/* custom blocks */
import block0 from "./CreateCompetitorDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports